var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.865 8.478a.665.665 0 0 1-.005-.944v-.007l3.997-3.994a.66.66 0 0 1 .946 0 .67.67 0 0 1 0 .945L4.94 7.341h7.727c.367 0 .667.293.667.666 0 .366-.3.665-.667.665H4.952l2.857 2.856c.26.253.26.679 0 .938h-.007a.7.7 0 0 1-.473.193l.008.008a.676.676 0 0 1-.473-.193L2.867 8.479l-.002-.001Z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f6e544f4b28e46ff2753c995de9a47cc.svg";
export { ForwardRef as ReactComponent };